var YWS = YWS || {};
YWS.product = YWS.product || {};


YWS.product.sizeChart = (function(YWS, $) {
  
  function bindEvents() {
    $(document).on('click', '.product-takeover__toggle', function(event) {
      event.preventDefault();
      
      // show size chart modal
      $('body').addClass('modal--open');
      $('#size-chart').css({display: 'block', opacity: 1});
    });
    
    $(document).on('click', '.product-takeover__close', function(event) {
      event.preventDefault();
      
      // hide size chart modal
      $('body').removeClass('modal--open');
      $('#size-chart').css({display: 'none', opacity: 0});
    });
    
    $(document).on('click', '.product-takeover', function(event) {
      event.preventDefault();
      
      // hide size chart modal
      $('body').removeClass('modal--open');
      $('#size-chart').css({display: 'none', opacity: 0});
    });
  }
  
  
  return {
    init: function() {
      bindEvents();
    }
  }
  
  
})(YWS, jQuery);


$(document).ready(function() {
  
  if($('body.product-detail').length) {
    
    // disable takeover
    $(document).off('click', '.product-takeover__toggle');
    
    // disable product description truncation
    var fullDesc = $('.full-desc').text();
    $('.product-description').html('<p>' + fullDesc + '</p>');
    
    YWS.product.sizeChart.init();
  }
  
});